import { useDeviceType } from '@cian/ui-kit/responsive';
import { IJsonQuery } from '@cian/api-models/common/json_query';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../../types/redux';
import { selectListingUrl } from '../../../selectors/urls';
import { ListingButton } from '../../../components/Navigation/buttons';
import { trackListingClick } from './analytics';
import { useApplicationContext } from '../../ApplicationContext';

export const ListingButtonContainer: React.FC = () => {
  const url = useSelector(selectListingUrl);
  const {
    custom: { subdomain },
  } = useApplicationContext();
  const targetSubdomain = useSelector<IApplicationState, string>(state => state.results.subdomain);
  const jsonQuery = useSelector<IApplicationState, IJsonQuery>(state => state.results.jsonQuery);
  const deviceType = useDeviceType();
  const [targetDomain, setTargetDomain] = React.useState(`${targetSubdomain}.cian.ru`);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      event.preventDefault();

      const href = event.currentTarget.href;
      trackListingClick(jsonQuery);

      setTimeout(() => {
        if (deviceType === 'desktop') {
          window.open(href, '_blank');
        } else {
          document.cookie = 'flavour=mobile;domain=.cian.ru;path=/';
          window.location.href = href;
        }
      }, 300);
    },
    [deviceType, jsonQuery],
  );

  React.useEffect(() => {
    setTargetDomain(window.location.hostname.replace(`${subdomain}.`, `${targetSubdomain}.`));
  }, [subdomain, targetSubdomain]);

  return <ListingButton url={`//${targetDomain}${url}`} onClick={handleClick} />;
};
